import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("afc_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const buildImageUrl = (src) => {
  if (!src) return "";
  if (src.startsWith("http")) return src;
  if (src.startsWith("/api/")) return `${BACKEND_URL}${src}`;
  return `${API}/files/${src}`;
};
